import React, { useState } from 'react';
import { salvarSessao, sessao } from '../api';

const MENU = [
  { rota: '#/painel', nome: 'Painel' },
  { rota: '#/empresas', nome: 'Empresas' },
  { rota: '#/planos', nome: 'Planos' },
  { rota: '#/admins', nome: 'Administradores' },
  { rota: '#/logs', nome: 'Histórico' },
];

export default function Layout({ rota, titulo, children }) {
  const [aberta, setAberta] = useState(false);
  const s = sessao();
  const hoje = new Date().toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long' });

  function sair() {
    salvarSessao(null);
    window.location.hash = '#/login';
  }

  return (
    <div className="app">
      <aside className={'sidebar' + (aberta ? ' aberta' : '')} onClick={() => setAberta(false)}>
        <div className="marca">Controla Banheiros<small>Painel de controle</small></div>
        <nav>
          {MENU.map(m => (
            <a key={m.rota} href={m.rota} className={rota.startsWith(m.rota) ? 'ativo' : ''}>{m.nome}</a>
          ))}
        </nav>
        <div className="rodape">
          {s && s.admin ? (s.admin.nome || s.admin.email) : ''}
          <br />
          <button onClick={sair}>Sair</button>
        </div>
      </aside>
      <div className="conteudo">
        <div className="topo">
          <div className="linha">
            <button className="menu-btn" onClick={() => setAberta(true)}>☰</button>
            <h1>{titulo}</h1>
          </div>
          <div className="data">{hoje}</div>
        </div>
        <div className="pagina">{children}</div>
      </div>
    </div>
  );
}
